<template>
  <UIDrawer
    :is-open
    :z-index
    title="JSON data"
    :allow-tray
    @minimize="handleMinimize"
    @close="handleClose"
  >
    <UIPreloader v-if="loading" message="Loading JSON data..." />
    <UIJsonTree v-else :json size="sm">JSON data</UIJsonTree>
  </UIDrawer>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'

import { LinkedDataPosition, ModalClass } from '@types'

import { useLinkedDataPositionsStore } from '@/store/linkedData/positions'

import { useNotifications } from '@/plugins/notification'

import { UIJsonTree, UIPreloader } from '@ui/core'
import { UIDrawer } from '@ui/modals'
import { handleCatchedError } from '@/helpers/common'

type Props = {
  modal: ModalClass<any>
  position: LinkedDataPosition
}
const props = defineProps<Props>()

const linkedDataPositionsStore = useLinkedDataPositionsStore()

const { error } = useNotifications()

const loading = ref(false)
const json = ref()

const isOpen = computed(() => props.modal.isOpened)
const zIndex = computed(() => props.modal.zIndex)
const allowTray = computed(() => props.modal.allowTray)

const handleClose = () => {
  props.modal.close()
}

const handleMinimize = () => {
  props.modal.hide()
}

const fetch = async () => {
  json.value = undefined
  try {
    loading.value = true
    const response = await linkedDataPositionsStore.fetchSingle(props.position.id)
    json.value = response.data
  } catch (e) {
    error({
      message: 'Failed to load JSON data',
    })
    handleCatchedError(e as string, { id: props.position.id })
  } finally {
    loading.value = false
  }
}

watch(() => props.position.id, () => {
  fetch()
}, { immediate: true })
</script>
